export const getActiveMarket = () => {
	return localStorage.getItem("activeMarket") || "PL";
};
